var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default panel-dashboard"},[_c('div',{staticClass:"panel-body"},[_c('canvas',{attrs:{"width":"800","height":"250"}}),_vm._v(" "),_c('TheValueChartBreakdownModal',{attrs:{"user":_vm.user,"month":_vm.month}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }